import { render, staticRenderFns } from "./Search.vue?vue&type=template&id=5b75471c&scoped=true"
import script from "./Search.vue?vue&type=script&setup=true&lang=js"
export * from "./Search.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Search.vue?vue&type=style&index=0&id=5b75471c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b75471c",
  null
  
)

export default component.exports